<template>
  <div>
    <BreadCrumb v-if="this.mode !== 'comp'" :data="breadCrumb" />
    <span style="display: none">{{ warehouses }}</span>
    <Table
      :fields="fields" :items="movementsList" :filtered="filtered" type="List" 
      :loading="isLoading" :limit="limit" :setLimit="setLimit" :page="page" :setPage="setPage" 
      :pageData="pageInfo" :actions="actions" :actionEvent="actionEvent"
      :inputs="inputs" :search="search" :gSearch='gSearch' addUrl="Stock/Movements/Add"
    />
    <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import Table from "@/components/Table";
import Modals from "./modals/";

let breadCrumb = [
  { label: "Stoklar", url: "/Stock/List" },
  { label: "Hareketler", url: "/Movements/List" }
];

let fields = [
  { key: "product", label: "Stok Kodu", keys: ["product", "barcode"] },
  { key: "quantity", label: "Adet", keys: ["quantity"] },
  { key: "operation", label: "Tip", type:"badge", keys: ["operation", "desc"] },
  { key: "track", label: "Takip Durumu", type:"data", data:{true: {text: 'Takip Dışı', variant: 'dark'}, false: {text: 'Takipte', variant: 'success'}}, keys: ["is_untrack"] },
  { key: "customer", type: 'multiple', label: "Hareket", keys: [["warehouse", "name"], ["to_warehouse", "name"],["customer", "name"]] },
  { key: "user", label: "Oluşturan Kişi", keys: ["user", "name"] },
  { key: "date", type:"date", label: "İşlem Tarihi", keys: ["date"] },
  { key: "create", type:"date", label: "Oluşturma Tarihi", keys: ["created_at"] },
  { key: "actions", label: "İşlemler" },

];
let inputs = [
  { key: "productBarcode", label: "Stok Kodu", type: "String", checked: false, val: "" },
  { key: "seriNo", label: "Seri No", type: "String", checked: false, val: "" },
  { key: "customerName", label: "Müşteri İsmi", type: "String", checked: false, val: "" },
  { key: "recordType",label: "Tip", type: "Select", array:[
    {text: 'Alış', value: 'in'},
    {text: 'Satış', value: 'out'},
    {text: 'Arıza Girişi', value: 'faul-in'},
    {text: 'Arıza Çıkışı', value: 'faul-out'},
  ], checked: false, val: "",},
  { key: "isUntrack",label: "Takip Durumu",type: "Select", array:[
    {text: 'Tümü', value: 0},
    {text: 'Takipte', value: 1},
    {text: 'Takip Dışı', value: 2},
  ],checked: false, val: "",},
  { key: "warehouseID",label: "Depo",type: "Select", array: [], checked: false, val: "",},
  { key: "created-begin-date",label: "Oluşturma Tarihi (Başlangıç)",type: "Date",checked: false, val: "",},
  { key: "created-end-date",label: "Oluşturma Tarihi (Bitiş)",type: "Date",checked: false, val: "",},
  { key: "operation-begin-date",label: "İşlem Tarihi (Başlangıç)",type: "Date",checked: false, val: "",},
  { key: "operation-end-date",label: "İşlem Tarihi (Bitiş)",type: "Date",checked: false, val: "",},



];
let filtered = ["product", "operation", "quantity", "created_at", "customer", "user", "date", "track", "actions"];
let actions = [
  { key: "detail", text: "Hareket Detayı" },
  { key: "edit", text: "Hareket Düzenle" },
  { key: "delete", text: "Hareketi Sil" },
];
export default {
  name: "MovementsList",
  watch: {
    limit(val) {
      this.params["limit"] = val;
      this.$store.dispatch("fetchMovements", this.params);
    },
    offset(val) {
      this.params["offset"] = val;
      this.$store.dispatch("fetchMovements", this.params);
    },
  },
  data: function () {
    return {
      breadCrumb, fields, filtered, limit: 10, page: 1, offset: 0, 
      currentForm: "StockMovements", inputs, actions,
      modalOpen: false, modalProps: {}, modalName: "",
      params: {
        limit: 10,
        offset: 0,
      },
    };
  },
  components: {
    BreadCrumb, Table, Modals
  },
  props: {
    mode: String,
  },
  computed: {
    isLoading() {
      return this.$store.getters.getStockLoading
    },
    movementsList() {
      return this.$store.getters.movementsList
    },
    pageInfo(){
      return this.$store.getters.getMovementPageInfo
    },
    warehouses() {
      let array = []
      this.$store.getters.getWarehouses.map(w => {
        array.push({text: w.name, value: w.id})
      })
      let index = this.inputs.findIndex(i => i.key == 'warehouseID')
      if(index >= 0)
        this.inputs[index].array = array
      return array
    },
  },
  methods: {
    search(){
      this.inputs.map((input) => {
        input.checked ? this.params[input.key] = input.val : delete this.params[input.key] 
      })
      this.$store.dispatch('fetchMovements', this.params)
    },
    gSearch(data){
      data.length > 0 ? this.params['search'] = data : delete this.params['search']
      this.$store.dispatch('fetchMovements', this.params)
    },
    setLimit:function(limit){
      this.limit = limit
    },
    setPage: function (page) {
      if(page > 0){
        this.page = page
        this.offset = ((page-1) * this.limit)
      }
    },
    actionEvent: async function (key, data) {
      this.openModal(true, key, { ...data, type: key })
    },
    openModal: function(state, modal, props){
      this.modalOpen = state
      if(state){
        this.modalProps = props
        this.modalName = modal
      }
    },
  },
  created() {
    this.$store.dispatch("fetchMovements", this.params);
    this.$store.dispatch("warehouse_get");
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/MovementsList.vue